import React from 'react';
import { BrowserRouter, Route } from 'react-router-dom';
import {
  ApolloClient,
  InMemoryCache,
  ApolloProvider,
  useQuery,
  gql
} from "@apollo/client";
import { Security, SecureRoute, ImplicitCallback } from '@okta/okta-react';
//import { ApolloProvider } from "@apollo/react-components";

import Home from './pages/admin';
import EditForm from './pages/editResourceform';
import Upload from './pages/createResource';
import Update from './pages/updateResource';
import ThankYou from './pages/thankyou';

const client = new ApolloClient({
  uri: process.env.REACT_APP_GRAPHQL_URL,
  cache: new InMemoryCache()
  
});

const config = {
  issuer:process.env.REACT_APP_OKTA_ORG_URL,
  redirect_uri: window.location.origin + "/implicit/callback",
  client_id: process.env.REACT_APP_OKTA_CLIENT_ID
}; 

function App() {
  return (
  <ApolloProvider client={client}>
     <BrowserRouter>
    <Security issuer={config.issuer}
                  client_id={config.client_id}
                  redirect_uri={config.redirect_uri}
        >
   <div className="App">        
   <SecureRoute exact path='/' component={Home} />
            <SecureRoute exact path='/edit' component={EditForm} />
            <SecureRoute exact path='/view-resources' component={Update} />
            <SecureRoute exact path='/add-resource' component={Upload} />
            <SecureRoute exact path='/thankyou' component={ThankYou} /> 
       
        <Route path='/implicit/callback' component={ImplicitCallback}/>    
        
      </div>
      </Security>
      </BrowserRouter>
      
  </ApolloProvider>
    );
  }
export default App;
